import React from 'react'
import PropTypes from 'prop-types'

const renderTextInputWithFeedback = ({ className, input, placeholder, type, label, meta }) => {
  const { touched, error } = meta
  return (
    <div className="form-group" id={label}>
      {label && <label>{label}</label>}
      <input
        {...input}
        type={type}
        className={`form-control ${className}`}
        placeholder={placeholder}
      />
      {touched && error && (
        <h6 className="text-danger small text-justify" style={{ marginTop: '5px' }}>
          {error}
        </h6>
      )}
    </div>
  )
}

renderTextInputWithFeedback.propTypes = {
  className: PropTypes.string,
  input: PropTypes.any.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.any,
  label: PropTypes.string,
}

renderTextInputWithFeedback.defaultProps = {
  type: 'text',
  placeholder: '',
}

export default renderTextInputWithFeedback



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderTextInputWithFeedback.js